var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.796,
    height: 16.505,
    viewBox: "0 0 23.796 16.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-_history-folder-01",
    d: "M24.591,16.313V11.054a.546.546,0,0,0-.546-.546H14.837a.486.486,0,0,1-.421-.228l-.945-1.423a.513.513,0,0,0-.421-.228H7.006a.546.546,0,0,0-.546.546v13.4a.546.546,0,0,0,.546.546H24.694a.158.158,0,0,0,.137-.08l3.426-6.693a.022.022,0,0,0-.023-.023H10.318a.278.278,0,0,0-.262.159L6.824,22.789",
    transform: "translate(-5.46 -7.63)",
    fill: "none",
    stroke: "#002030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDark);
export default __webpack_public_path__ + "static/media/Folder-Dark.068f51fe5e99b01bd8626feb920711b3.svg";
export { ForwardRef as ReactComponent };